export class OktaToken {
  accessToken: string;
  tokenType: string;
  expireIn: number;
  scope: string;
  refreshToken: string;
  idToken: string;

  constructor(res: any) {
    for (let item in res) {
      if (!item) {
        continue;
      }
      const newKey = item.charAt(0).toLowerCase() + item.slice(1);
      this[newKey] = res[item];
    }
  }
}
